<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 企业简介
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form ref="adoptForm" :rules="rules" :model="adoptForm" label-width="100px" >
               <el-form-item prop="top_name" label="顶部信息">
                     <el-input v-model="adoptForm.top_name"  style="width:500px"></el-input>
               </el-form-item>
                <el-form-item prop="introduction" label="简介内容" >
                    <mavon-editor  v-model="adoptForm.introduction" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height:600px;" />
                     <!-- <el-input v-model="adoptForm.introduction"  type="textarea"
                    :autosize="{ minRows: 1, maxRows: 10}" style="width:500px"></el-input> -->
               </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveEdit()">修改</el-button>
            </span>
        </div>
    </div>
</template>

<script>


import { post } from '../../../api/request';
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
export default {
    name: 'basetable',
    data() {
        return {
            html:'',
            content:'',
            array:[],
            adoptForm:{
                top_name:'',
                introduction:'',
            },
            formDate:'',
            fileList:[],
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query: {
                notice: '',
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 7,
            //添加数据
            addVisiable:false,
            addForm:{
               notice:'',
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                top_name: [
                    { required: true, message: '请输入顶部信息', trigger: 'blur' },
                ],
                introduction: [
                    { required: true, message: '请输入简介内容', trigger: 'blur' },
                ]
            },
            //获取id
            idx: -1,
            id: -1
        };
    },
    components: {
        mavonEditor
    },
    
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.firstadd()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
        this.firstadd()
    },
    methods: {
        $imgAdd(pos, $file){
            var formdata = new FormData();
            formdata.append('file', $file);
            // 这里没有服务器供大家尝试，可将下面上传接口替换为你自己的服务器接口
            post('admin/file/url',formdata).then((res) => {
                this.$refs.md.$img2Url(pos, res.data);
            })
        },
        change(value, render){
            // render 为 markdown 解析后的结果
            this.html = render;
        },
        submit(){
            this.$message.success('提交成功！');
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('notice',this.query.notice)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/home/topinfo',formdata).then(res => {
                if(res.data.data[0]){
                    this.adoptForm = res.data.data[0]
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        firstadd() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('top_name',this.adoptForm.top_name)  
            formdata.append('introduction',this.adoptForm.introduction)
            post('admin/home/fistadd',formdata).then(res => {
               
            });
        },
        // 保存编辑
        saveEdit() {
            console.log(this.html)
            this.$refs['adoptForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.adoptForm.id)
                    formdata.append('top_name',this.adoptForm.top_name)  
                    formdata.append('introduction',this.adoptForm.introduction)
                    formdata.append('lable',this.html)
                    post("admin/home/topupdate",formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
